import { findIndex, propEq, last, head, length } from 'ramda';

const findStatusIndex = statusId => findIndex(propEq('id', statusId));
const emptyRoute = '/';

export const getNextStepUrl = (statuses, activeStatus, confirmedFlowStepId = null) => {
  if (statuses.length === 0) {
    return emptyRoute;
  }

  if (confirmedFlowStepId) {
    const confirmedFlowNextStepIndex = findStatusIndex(confirmedFlowStepId)(statuses);
    const confirmedFlowNextStep = statuses[confirmedFlowNextStepIndex];
    return confirmedFlowNextStep.route;
  }

  const thanksStep = last(statuses);
  const currentStepIndex = findStatusIndex(activeStatus)(statuses);
  const nextStep = currentStepIndex < length(statuses) - 1 ? statuses[currentStepIndex + 1] : thanksStep;
  return nextStep.route;
};

export const getPreviousStepUrl = (statuses, activeStatus) => {
  if (statuses.length === 0) {
    return emptyRoute;
  }
  const rlpStep = head(statuses);
  const currentStepIndex = findStatusIndex(activeStatus)(statuses);
  const previousStep = currentStepIndex > 0 ? statuses[currentStepIndex - 1] : rlpStep;
  return previousStep.route;
};
